import { render, staticRenderFns } from "./RelatedProject.vue?vue&type=template&id=81969864&scoped=true"
import script from "./RelatedProject.vue?vue&type=script&lang=js"
export * from "./RelatedProject.vue?vue&type=script&lang=js"
import style0 from "./RelatedProject.vue?vue&type=style&index=0&id=81969864&prod&lang=scss&scoped=true"
import style1 from "./RelatedProject.vue?vue&type=style&index=1&id=81969864&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81969864",
  null
  
)

export default component.exports